export default __webpack_public_path__ + "static/solutions_background-4b0ea57737b4631a90d239e76400eee9.jpg";